import { Box, Divider, Typography } from '@mui/material';
import { theme } from 'config/theme';
import { Link } from 'react-router-dom';

type TopContributingHighlightProps = {
  label: string;
  icon: JSX.Element;
  name: string;
  url?: string;
};

function TopContributingHighlight({ label, icon, name, url }: TopContributingHighlightProps) {
  const DeatilsComponent = () => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {icon}
        <Typography sx={{ ml: 1, color: theme.palette.custom.tuna, fontWeight: 700 }}>
          {name}
        </Typography>
      </Box>
    );
  };
  return (
    <>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box>
        <Typography sx={{ color: theme.palette.custom.mistBlue, fontSize: 14, fontWeight: 700 }}>
          {label}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          {url ? (
            <Link to={url}>
              <DeatilsComponent />
            </Link>
          ) : (
            <DeatilsComponent />
          )}
        </Box>
      </Box>
    </>
  );
}

export default TopContributingHighlight;
